module.exports = __webpack_public_path__ + "static/media/verticalRectangle_purple.27dad988.svg";